import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

interface SurveyHistogramChartProps {
    question: string;
    results: number[];
}

const SurveyHistogramChart: React.FC<SurveyHistogramChartProps> = ({ question, results }) => {
    // Define the number of bins
    const numBins = 10;
    const min = Math.min(...results);
    const max = Math.max(...results);
    const binWidth = Math.ceil((max - min + 1) / numBins);

    // Create bins and count the number of data points in each bin
    const bins = Array.from({ length: numBins }, (_, i) => ({
        binStart: min + i * binWidth,
        binEnd: min + (i + 1) * binWidth - 1,
        count: 0,
    }));

    results.forEach(value => {
        const binIndex = Math.min(Math.floor((value - min) / binWidth), numBins - 1);
        bins[binIndex].count += 1;
    });

    const data = {
        labels: bins.map(bin => Math.round(bin.binStart) === Math.round(bin.binEnd) ? `${Math.round(bin.binStart)}` : `${Math.round(bin.binStart)} - ${Math.round(bin.binEnd)}`),
        datasets: [
            {
                label: 'Frequency',
                data: bins.map(bin => bin.count),
                backgroundColor: 'rgba(61, 168, 226, 0.5)',
                borderColor: 'rgba(61, 168, 226, 1)',
                borderWidth: 1,
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'bottom' as const,
            },
            title: {
                display: true,
                text: question,
            },
        },
        scales: {
            x: {
                ticks: {
                    autoSkip: false,
                },
            },
        },
    };

    return <Bar data={data} options={options} />;
};

export default SurveyHistogramChart;